import React, { useState, useEffect } from "react";
import { Modal, Button, Input, Form } from "antd";
import Permission from "../../components/permission/index";
// import firebase from '../../config/firebase';
import perfilService from "../../service/perfil.service";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import userService from "../../service/user.service";

export default function CreatePerfil() {

    const user = useSelector(state => state.user);

    const [loading, setLoading] = useState(false);
    const [update, setUpdate] = useState(false);
    const [record, setRecord] = useState(null);

    let navigate = useNavigate();
    const location = useLocation();
    // const permissoes = location.state?.permissoes;

    const initialPermissoes = {
        freight: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        client: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        driver: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        shipper: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        user: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        mdfe: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        import: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        payment: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        tableIcms: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        ocurrence: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        tablePrice: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        accompaniment: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        perfil: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
    };

    const [permissoes, setPermissoes] = useState(location.state?.permissoes || initialPermissoes);
    const [view, setView] = useState(location.state?.viewOnly);

    const [selecionarTodosGeral, setSelecionarTodosGeral] = useState(false);

    const handleChange = (grupo, campo) => {
        setPermissoes((prev) => {
            let novoGrupo;

            if (campo === "selecionarTodos") {
            const novoValor = !prev[grupo].selecionarTodos;
            novoGrupo = {
                selecionarTodos: novoValor,
                isView: novoValor,
                isCreate: novoValor,
                isEdit: novoValor,
                isDelete: novoValor,
            };
            } else {
            novoGrupo = {
                ...prev[grupo],
                [campo]: !prev[grupo][campo],
            };

            // recalcula o "selecionarTodos" do grupo
            const todosSelecionados =
                novoGrupo.isView &&
                novoGrupo.isCreate &&
                novoGrupo.isEdit &&
                novoGrupo.isDelete;
            novoGrupo.selecionarTodos = todosSelecionados;
            }

            const novoEstado = {
            ...prev,
            [grupo]: novoGrupo,
            };

            // recalcula o "selecionarTodosGeral"
            const todosOsGruposMarcados = Object.values(novoEstado).every(
            (g) => g.selecionarTodos
            );
            setSelecionarTodosGeral(todosOsGruposMarcados);

            return novoEstado;
        });
    };

    // handler geral
    const handleSelecionarTodosGeral = () => {
        setPermissoes((prev) => {
            const novoValor = !selecionarTodosGeral;
            const novoEstado = {};

            for (const grupo in prev) {
            novoEstado[grupo] = {
                selecionarTodos: novoValor,
                isView: novoValor,
                isCreate: novoValor,
                isEdit: novoValor,
                isDelete: novoValor,
            };
            }

            // atualiza o estado geral
            setSelecionarTodosGeral(novoValor);

            return novoEstado;
        });
    };

    const [form] = Form.useForm();

    const onFinish = async (values) => {
        setLoading(true);
        try {

            const list = await perfilService.getPerfis();

            if (!update && list.some((perfil) => perfil.nomePerfil.toLowerCase() === values.nomePerfil.toLowerCase())) {
                alert("Já existe um perfil com esse nome. Por favor, escolha outro nome.");
                setLoading(false);
                return;
            }

            if (!update) {  
                await perfilService.savePerfil({
                    nomePerfil: values.nomePerfil,
                    permissoes: permissoes,
                    selecionarTodosGeral: selecionarTodosGeral,
                    uidShipper: user.uidShipper || "uid não encontrado",
                });
                alert("Perfil criado com sucesso!");
                navigate("/listPerfil");
            }
            else {
                await perfilService.updatePerfil(record.id, {
                    nomePerfil: values.nomePerfil,
                    permissoes: permissoes,
                    selecionarTodosGeral: selecionarTodosGeral,
                    uidShipper: user.uidShipper || "uid não encontrado",
                });
                await userService.updateUserPerfil(values.nomePerfil, permissoes, selecionarTodosGeral);
                debugger;
                alert("Perfil atualizado com sucesso!"); //TODO alterar para modal de menssagem
                navigate("/listPerfil");
            }
        } 
        catch (error) {
            console.error("Erro ao salvar perfil:", error);
            alert("Houve um erro ao salvar esse perfil!");
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (location.state && location.state.record) {
            const record = location.state.record;
            form.setFieldsValue({
                nomePerfil: record.nomePerfil,
            });
            setPermissoes(record.permissoes);
            setSelecionarTodosGeral(record.selecionarTodosGeral);
            setRecord(record);
            setUpdate(true);
        }
    }, [location.state]);

    return (
        <>
            <NewMiniDrawer divOpen={
                <>
                    <div className="container mb-3">
                        <div className="row">
                            <div className="col-5">
                                {
                                    update ? <h4>Editar Perfil</h4> : <h4>Cadastrar Perfil</h4>
                                }
                            </div>
                        </div>
                    </div>
                    <Form style={{ padding: "0 100px", margin: 0, justifyContent: "flex-start" }} form={form} layout="vertical" onFinish={onFinish} >
                        <Form.Item
                            className="Form"
                            name="nomePerfil"
                            label="Nome do Perfil"
                            rules={[{ required: true, message: "Informe o nome do perfil" }]}
                        >
                            <Input disabled={view} placeholder="Digite o nome do perfil" />
                        </Form.Item>

                        <Form.Item className="Form" label="Permissões" name="permissions">
                            <Permission
                                view={view}
                                permissoes={permissoes}
                                handleChange={handleChange}
                                handleSelecionarTodosGeral={handleSelecionarTodosGeral}
                                selecionarTodosGeral={selecionarTodosGeral}
                            />
                        </Form.Item>
                        {/* Botões fora do modal */}
                        <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
                            <Button onClick={() => {form.resetFields(); navigate("/listPerfil")}}>Cancelar</Button>
                            <Button disabled={view} type="primary" htmlType="submit" loading={loading}>
                                {
                                    update ? "Atualizar" : "Salvar"
                                }
                            </Button>
                        </div>
                    </Form>
                </>
            } />
        </>
    )

}